<ion-content class="confidential-modal-content">
  <div class="modal-close-button" (click)="closeModal()">
    <ion-icon name="close"></ion-icon>
  </div>
  <div class="confidential-modal-body">
    <h1 class="modal-title">{{ 'PRIVACY.TITLE' | translate }}</h1>

    <p><strong>{{ 'PRIVACY.LAST_UPDATE' | translate }}</strong></p>

    <h3>{{ 'PRIVACY.SECTION_1_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_1_P1' | translate }}</p>

    <h3>{{ 'PRIVACY.SECTION_2_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_2_P1' | translate }}</p>
    <ul>
      <li>{{ 'PRIVACY.SECTION_2_ITEM_1' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_2_ITEM_2' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_2_ITEM_3' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_2_ITEM_4' | translate }}</li>
    </ul>

    <h3>{{ 'PRIVACY.SECTION_3_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_3_P1' | translate }}</p>
    <ul>
      <li><strong>{{ 'PRIVACY.SECTION_3_LOC_TITLE' | translate }}</strong> {{ 'PRIVACY.SECTION_3_LOC_DESC' | translate }}</li>
      <li><strong>{{ 'PRIVACY.SECTION_3_LOC_BG_TITLE' | translate }}</strong> {{ 'PRIVACY.SECTION_3_LOC_BG_DESC' | translate }}</li>
      <li><strong>{{ 'PRIVACY.SECTION_3_LOC_PURPOSE_TITLE' | translate }}</strong>
        <ul>
          <li>{{ 'PRIVACY.SECTION_3_LOC_PURPOSE_1' | translate }}</li>
          <li>{{ 'PRIVACY.SECTION_3_LOC_PURPOSE_2' | translate }}</li>
          <li>{{ 'PRIVACY.SECTION_3_LOC_PURPOSE_3' | translate }}</li>
        </ul>
      </li>
      <li><strong>{{ 'PRIVACY.SECTION_3_LOC_TRANS_TITLE' | translate }}</strong> {{ 'PRIVACY.SECTION_3_LOC_TRANS_DESC' | translate }}</li>
    </ul>

    <h3>{{ 'PRIVACY.SECTION_4_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_4_P1' | translate }}</p>
    <ul>
      <li>{{ 'PRIVACY.SECTION_4_ITEM_1' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_4_ITEM_2' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_4_ITEM_3' | translate }}</li>
    </ul>

    <h3>{{ 'PRIVACY.SECTION_5_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_5_P1' | translate }}</p>

    <h3>{{ 'PRIVACY.SECTION_6_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_6_P1' | translate }}</p>
    <ul>
      <li>{{ 'PRIVACY.SECTION_6_ITEM_1' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_6_ITEM_2' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_6_ITEM_3' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_6_ITEM_4' | translate }}</li>
      <li>{{ 'PRIVACY.SECTION_6_ITEM_5' | translate }}</li>
    </ul>

    <h3>{{ 'PRIVACY.SECTION_7_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_7_P1' | translate }}</p>

    <h3>{{ 'PRIVACY.SECTION_8_TITLE' | translate }}</h3>
    <p>{{ 'PRIVACY.SECTION_8_P1' | translate }}</p>
  </div>
</ion-content>

